import { Role } from './role';
import { PermissionLevel } from '../../shared/permission/permission';

export class User {
  public username: string;
  private _roles: Array<Role> = [];

  public static fromDTO(userDto: UserDTO): User {
    const user: User = new User(
      userDto.firstname,
      userDto.lastname,
      userDto.type,
      userDto.oid,
      userDto.email
    );
    user.username = userDto.username;
    return user;
  }

  constructor(
    public firstName: string,
    public lastName: string,
    public type: string,
    public id: number,
    public email: string
  ) {}

  public get roles(): Array<Role> {
    return this._roles;
  }

  public set roles(value: Array<Role>) {
    this._roles = value;
  }

  /**
   * @deprecated Use `permissionLevelFull` instead.
   */
  public get permissionLevel(): PermissionLevel {
    switch (this.type) {
      case 'admin':
        return PermissionLevel.ADMIN;
      case 'manager':
        return PermissionLevel.MANAGER;
      default:
        if (
          this.roles.some(
            (role: Role) => role.name === "Don't allow restricted management"
          )
        ) {
          return PermissionLevel.EMPLOYEE;
        } else {
          return PermissionLevel.MANAGER;
        }
    }
  }

  public get permissionLevelFull(): PermissionLevel | null {
    /*
     * This property is used as 1-1 mapping of type to permissionLevel.
     * It was added as separate property to prevent regressions in deprecated code
     * that's related to old permissionLevel() property
     */
    switch (this.type) {
      case 'super_admin':
        return PermissionLevel.SUPER_ADMIN;
      case 'partner':
        return PermissionLevel.PARTNER;
      case 'admin':
        return PermissionLevel.ADMIN;
      case 'manager':
        return PermissionLevel.MANAGER;
      case 'employee':
        return PermissionLevel.EMPLOYEE;
      default:
        return null;
    }
  }
}

export interface UserDTO {
  firstname: string;
  lastname: string;
  type: string;
  oid: number;
  email: string;
  username: string;
}
